// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Uv81","colBig":"styles_colBig__2TWwB","colSmall":"styles_colSmall__2UWl5"};